import React, {FC, PropsWithChildren} from 'react';

import {Trans} from '../../../../../libs/shared/core/src/helpers/internationalization/react';
import {ClickEventHandler} from '../../../../../libs/shared/core/src/helpers/react/reactHelpers';
import {Button} from '../../../../../libs/shared/ui/src/components/buttons/button';
import {ButtonVariantsEnum} from '../../../../../libs/shared/ui/src/components/buttons/buttonConstants';
import {VisualSizesEnum} from '../../../../../libs/shared/ui/src/styles/commonStyles';

/*
 * Props.
 */

interface FilterRightClearButtonProps {
  onClear: ClickEventHandler;
}

/*
 * Component.
 */

export const FilterRightClearButton: FC<PropsWithChildren<FilterRightClearButtonProps>> = ({
  children,
  onClear,
}) => (
  <Button variant={ButtonVariantsEnum.LINK} size={VisualSizesEnum.SMALL} onClick={onClear}>
    {children ?? <Trans id="select-filter-header-clear">Clear</Trans>}
  </Button>
);
